import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.css";

const VaporAccordion = props => {

  const { itemId, children, description, iconOpened, iconClosed, maxHeight, onChange, opened, size, title, autoOpen, autoOpenInit } = props;

  const [open, setOpen] = React.useState(autoOpenInit);
  const isOpen = (opened || (open && autoOpen));

  let iconToUse = isOpen ? ["far", "chevron-up"] : ["far", "chevron-down"];
  if (iconOpened) {
    if (typeof iconOpened === "object") {
      iconToUse = isOpen ? iconOpened : iconClosed;
    } else {
      iconToUse = ["far", isOpen ? iconOpened : iconClosed];
    }
  }

  const handleOpen = () => {
    setOpen(!open);
    if (onChange)
      if (!opened) {
        onChange(itemId);
      } else {
        onChange(null);
      }
  };

  return <div className={"ts-vapor-accordion ts-vapor-accordion-" + size + (isOpen ? " ts-vapor-accordion-opened" : "")}>
    <div onClick={handleOpen} className="ts-vapor-accordion-header">
      <div className="ts-vapor-accordion-title">
        <div className="ts-vapor-accordion-title-icon"><FontAwesomeIcon icon={iconToUse} /></div> {title}</div>
      <div className="ts-vapor-accordion-description">{description}</div>
    </div>
    <div
      style={{ maxHeight: isOpen ? maxHeight ? maxHeight : "520px" : "0" }}
      className={"ts-vapor-accordion-content" + (isOpen ? " ts-vapor-accordion-content-opened" : "")}>{isOpen ? children : null}</div>
  </div>;
};

VaporAccordion.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"])
};

VaporAccordion.defaultProps = {
  size: "medium"
};

export default VaporAccordion;